import { Component, OnInit, Input } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { LoaderService } from '@app/core/loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  @Input() isLoading = false;
  @Input() message: string | undefined;

  constructor(public authService: AuthenticationService, public loaderService: LoaderService) {}

  ngOnInit() {}
}
